import React from 'react';


function AppInstallGuide() {

    return (
        <>
            <div class="modal fade" id="AppInstallGuide" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5">📲 How to Install App (Staff Hisab)</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <div className='col-sm-6 mb-3 border border-radius rounded-2'>
                                    <p className='mb-0 mt-3'><b>🖼️ Step 1: Open the Web App in Chrome</b></p>
                                    <p className='mb-0'><small>Open Chrome browser on your phone.</small></p>
                                    <p className='mb-3'><small>Go to: https://app.staffhisab.in</small></p>
                                    <img src='/app/mobile-app-1.jpg' alt='step 1' className='w-100 mb-3' />
                                </div>
                                <div className='col-sm-6 mb-3 border border-radius rounded-2'>
                                    <p className='mb-0 mt-3'><b>🖼️ Step 2: Open the Chrome Menu</b></p>
                                    <p className='mb-0'><small>Tap the 3-dot menu (top-right corner of Chrome).</small></p>
                                    <p className='mb-3'><small>This opens a menu with several options.</small></p>
                                    <img src='/app/mobile-app-2.jpg' alt='step 2' className='w-100 mb-3' />
                                </div>
                                <div className='col-sm-6 mb-3 border border-radius rounded-2'>
                                    <p className='mb-0 mt-3'><b>🖼️ Step 3: Tap on "Add to Home screen"</b></p>
                                    <p className='mb-0'><small>From the menu, select “Add to home screen”.</small></p>
                                    <p className='mb-3'><small>A new popup will appear with app options.</small></p>
                                    <img src='/app/mobile-app-3.jpg' alt='step 3' className='w-100 mb-3' />
                                </div>
                                <div className='col-sm-6 mb-3 border border-radius rounded-2'>
                                    <p className='mb-0 mt-3'><b>🖼️ Step 4: Install the App</b></p>
                                    <p className='mb-0'><small>{`You’ll see a popup titled: “Install app – Staff Hisab - Attendance & Salary Manager”`}</small></p>
                                    <p className='mb-0'><small>{`Tap the “Install” button.`}</small></p>
                                    <p className='mb-3'><small>{`The app will now be installed and appear on your home screen like a regular app.`}</small></p>
                                    <img src='/app/mobile-app-4.jpg' alt='step 4' className='w-100 mb-3' />
                                </div>
                                <div className='col-sm-12'>
                                    <p className='mb-0'><b>✅ You're Done!</b></p>
                                    <p className='mb-0'><small>{`You can now access Staff Hisab directly from your home screen – no need to open the browser again.`}</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AppInstallGuide;